/* Bolt web WhatsApp attribution. No customer details stored in the event origin. */
(()=>{'use strict';
 const ENDPOINT='https://freshchat-receiver-production.up.railway.app/ir/whatsapp-web';
 const PHONE='50230712415';
 function code(){const bytes=new Uint8Array(12);crypto.getRandomValues(bytes);return Array.from(bytes,b=>String.fromCharCode(97+b%26)).join('');}
 function source(){return /producto/.test(location.pathname)?'p':/combo/.test(location.pathname)?'c':/mega/.test(location.pathname)?'m':'a';}
 function decorate(raw,kind){
  try{
   const u=new URL(raw,location.href);let message;
   if(u.origin==='https://freshchat-receiver-production.up.railway.app'&&u.pathname==='/ir/whatsapp-web')message=u.searchParams.get('t')||'';
   else if(u.hostname==='wa.me'&&u.pathname.replace(/\//g,'')===PHONE)message=u.searchParams.get('text')||'';
   else return raw;
   message=message.replace(/^Referencia web: BWEB-[A-Z]-[A-Z]{12}\n\n/,'');
   const origin='web-'+(kind||source())+'-'+code();
   const ref=origin.replace(/^web-/,'bweb-').toUpperCase();
   message='Referencia web: '+ref+'\n\n'+(message||'Hola, vengo de boltsupplements.com y quisiera asesoría.');
   // Never truncate a customer's order to fit the existing redirect endpoint.
   if(Array.from(message).length>8000){const direct=new URL('https://wa.me/'+PHONE);direct.searchParams.set('text',message);return direct.href;}
   const dest=new URL(ENDPOINT);dest.searchParams.set('o',origin);dest.searchParams.set('t',message);return dest.href;
  }catch{return raw;}
 }
 function click(e){if(e.defaultPrevented||!(e.target instanceof Element))return;const a=e.target.closest('a[href]');if(!a)return;const next=decorate(a.href,a.id==='cart-wa'?'c':undefined);if(next!==a.href)a.href=next;}
 document.addEventListener('click',click,true);
 document.addEventListener('auxclick',e=>{if(e.button===1)click(e);},true);
 // Covers button-driven redirects as well as dynamically rendered cart links.
 const commerce=window.BoltCommerce;
 if(commerce&&typeof commerce.wa==='function'){const original=commerce.wa;commerce.wa=function(...args){return decorate(original.apply(this,args),'c');};}
})();
